import type { FC } from 'react';
import type { CustomIconProps } from '../types';

const CloseIcon: FC<CustomIconProps> = ({ width, height, dataTestId }) => (
    <svg
        {...(dataTestId && { 'data-testid': dataTestId })}
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '16'}
        height={height ?? '16'}
        viewBox="0 0 16 16"
    >
        <path
            fill="#414042"
            fillRule="evenodd"
            d="M.138 15.197a.47.47 0 1 0 .665.665L8 8.666l7.197 7.196a.47.47 0 0 0 .665-.665L8.666 8 15.862.803a.47.47 0 0 0-.665-.665L8 7.334.803.138a.47.47 0 0 0-.665.665L7.334 8 .138 15.197Z"
            clipRule="evenodd"
        />
    </svg>
);

export default CloseIcon;
